import React from 'react';
import CourtesyPage from '../CourtesyPage';

const ExpiredCourtesyPage: React.FC = () => {

	return (
		<CourtesyPage messageID={'expired'} />
	)
}

export default ExpiredCourtesyPage;
